const host = window.location.origin;
let load = false
const loading = (bool) => {

  if (bool) {
    load = true
    setTimeout(()=>{
      if (load) {
        window.dispatchEvent(new Event("loading-true"));
      }
    }, 2000)
    
  } else {
    load = false
    window.dispatchEvent(new Event("loading-false"))
  }
  
};

const authHeader = (type) => {
  return new Promise((resolve) => {
    let token = window.sessionStorage.getItem("access_token") || null;
    let puid = window.sessionStorage.getItem("puid") || null;

    let headers = {
      "Content-Type": type || "application/json",
      Authorization: token,
      puid: puid,
      product: "loanportal"
    };

    if (type === "none") {
      delete headers["Content-Type"];
    }

    resolve(headers);
  });
};


export const get = (path) => {
  /* eslint-disable */
  return new Promise(async (resolve, reject) => {
    const options = {
      method: "GET",
      headers: await authHeader(),
    };
    loading(true);
    fetch(`${host}${path}`, options)
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(result);
        loading(false);
      })
      .catch((err) => {
        reject(err);
        loading(false);
      });
  });
};

export const post = (path, body, type) => {
  return new Promise(async (resolve, reject) => {
    const options = {
      method: "POST",
      headers: await authHeader(type),
      body: JSON.stringify(body),
    };
    loading(true);

    fetch(`${host}${path}`, options)
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(result);
        loading(false);
      })
      .catch((err) => {
        reject(err);
        loading(false);
      });
  });
};

export const postForm = (path, formData, type) => {
  return new Promise(async (resolve, reject) => {
    const options = {
      method: "POST",
      headers: await authHeader(type),
      body: formData,
    };
    loading(true);

    fetch(`${host}${path}`, options)
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(result);
        loading(false);
      })
      .catch((err) => {
        reject(err);
        loading(false);
      });
  });
};

export const put = (path, body, type) => {
  return new Promise(async (resolve, reject) => {
    const options = {
      method: "PUT",
      headers: await authHeader(type),
      body: JSON.stringify(body),
    };
    loading(true);

    fetch(`${host}${path}`, options)
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(result);
        loading(false);
      })
      .catch((err) => {
        reject(err);
        loading(false);
      });
  });
};

export const DownloadFile = (method, path, body) => {
  return new Promise(async (resolve, reject) => {
    const options = {
      method: method,
      headers: await authHeader(),
      body: JSON.stringify(body),
    };
    loading(true);

    fetch(`${host}${path}`, options)
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        resolve(blob);
        loading(false);
      })
      .catch((err) => {
        reject(err);
        loading(false);
      });
  });
};

export const del = (path, body) => {
  return new Promise(async (resolve, reject) => {
    const options = {
      method: "DELETE",
      headers: await authHeader(),
      body: JSON.stringify(body),
    };
    loading(true);

    fetch(`${host}${path}`, options)
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(result);
        loading(false);
      })
      .catch((err) => {
        reject(err);
        loading(false);
      });
  });
};

export const patch = (path) => {
  /* eslint-disable */
  return new Promise(async (resolve, reject) => {
    const options = {
      method: "PATCH",
      headers: await authHeader(),
    };
    loading(true);
    fetch(`${host}${path}`, options)
      .then((res) => {
        return res.json();
      })
      .then((result) => {
        resolve(result);
        loading(false);
      })
      .catch((err) => {
        reject(err);
        loading(false);
      });
  });
};